const destructureTheDate = (timeslot) => {
  const timeslotDate = new Date(timeslot)
  const localTimeslotDate = new Date(timeslotDate.toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }))
  const month = localTimeslotDate.getMonth() + 1
  const day = localTimeslotDate.getDay()
  const hours = localTimeslotDate.getHours()
  const minutes = localTimeslotDate.getMinutes()
  const time = hours * 100 + minutes
  return {
    month,
    day,
    time
  }
}

const timeslotsFilterCallbacks = {
  // Rule 1: Peak closure on Fridays in December from 17:30 to 19:30 (last reservation at 17:15, resumes at 19:45)
  rule1: (timeslot) => {
    const { month, day, time } = destructureTheDate(timeslot)

    if (month === 12 && day === 5 && time >= 1730 && time <= 1930) return false
    return true
  },
  // Rule 2: Peak closure on Saturdays in December from 17:30 to 19:30 (last reservation at 17:15, resumes at 19:45)
  rule2: (timeslot) => {
    const { month, day, time } = destructureTheDate(timeslot)

    if (month === 12 && day === 6 && time >= 1730 && time <= 1930) return false
    return true
  },
  // Rule 3: Peak closure on Sundays in December from 17:30 to 19:30
  rule3: (timeslot) => {
    const { month, day, time } = destructureTheDate(timeslot)

    if (month === 12 && day === 0 && time >= 1730 && time <= 1930) return false
    return true
  },
  // Rule 4: Peak closure on Thursdays in December from 17:30 to 19:30
  rule4: (timeslot) => {
    const { month, day, time } = destructureTheDate(timeslot)

    if (month === 12 && day === 4 && time >= 1730 && time <= 1930) return false
    return true
  }
}

const OTHER_PUBLIC_HOLIDAYS = [
  '2025-04-20',
  '2025-04-21',
  '2025-04-26',
  '2025-05-29'
]

const config = {
  type: 'voucherThreeCourse',
  activator: {
    type: 'notesField',
    text: 'AH driegangenmenu'
  },
  startDate: '2024/11/22',
  endDate: '2025/05/31',
  excludedDates: [
    '2024-12-25',
    '2024-12-26',
    '2024-12-31',
    '2025-01-01',
    '2025-01-06',
    '2025-04-20',
    '2025-05-29'
  ],
  // maxGroupSize: 14,
  locations: [
    {
      id: '073d8084-de0c-47b0-a1a5-8f26de05e6c6',
      name: 'Loetje Almere Centrum'
    },
    {
      id: '46f6ef79-3caa-4ad7-8e4c-a0d71ded7c2d',
      name: 'Loetje Almere Noorderplassen',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '31c1d494-f503-4012-9e28-d489b34b8c64',
      name: "Loetje Amsterdam aan 't IJ",
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '95e356b8-100c-4d24-9114-fc01a1e4e7c5',
      name: 'Loetje Amsterdam Café',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '60516784-248d-4623-81e6-e078e21c418c',
      name: 'Loetje Amsterdam Centraal'
    },
    {
      id: 'bd3c7497-7dde-4707-b82f-5916d560b0d7',
      name: 'Loetje Amsterdam de Pijp',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '8c4cbf41-116d-4b65-af4f-9445c7ceb303',
      name: 'Loetje Amsterdam Oost',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: 'e5cb1ae5-e33e-4704-ab84-151a10fd02cc',
      name: 'Loetje Amsterdam ZuidAs',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule4'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '421c8266-67d6-4706-af6a-fa55af035ddc',
      name: 'Loetje Arnhem',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '59c148c0-82f5-453c-a8f7-a6cf7252965d',
      name: 'Loetje Bergen',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2', 'rule3'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: 'f546558b-693d-407a-9652-3732a647d45c',
      name: 'Loetje Breda',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2', 'rule3'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '2d519dcc-47d3-478a-b13f-c7892791f2b1',
      name: 'Loetje Breukelen',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '870161c9-4eed-4e96-914a-ee8dca65ec62',
      name: 'Loetje Delft',
      timeslotsFilterCb: (timeslot) => {
        return ['rule2'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '6907a272-a59d-45f6-890e-6cae57604afb',
      name: 'Loetje Den Haag Binckhorst'
    },
    {
      id: 'c5049038-c04d-4812-aba9-0227d692bdf6',
      name: 'Loetje Den Haag Centrum',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '1451d489-91da-45bd-b9ba-a2badf8df562',
      name: 'Loetje Eindhoven',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '30077c4b-e4b4-4696-b4c7-ecbf5a2eca54',
      name: 'Loetje Enschede'
    },
    {
      id: 'c42fa1a7-4555-42fc-81b5-30e8c971dd1a',
      name: 'Loetje Gorssel',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule2', 'rule3'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: 'b81893d2-89d7-44d7-ac4a-d1180a337183',
      name: 'Loetje Haarlem',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2', 'rule3'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '87c967ba-6820-4c93-95ea-a5f42ce74d57',
      name: 'Loetje Hilversum'
    },
    {
      id: '088dc63e-cd1d-4a3a-a0b1-c707a27263b9',
      name: 'Loetje Houten',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '7acd55e7-a1e9-4fa2-93d7-8c7a641d03f3',
      name: 'Loetje Huizen'
    },
    {
      id: '2a42dc37-94e4-48de-9c72-d45e8f84879f',
      name: 'Loetje Laren',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2', 'rule3', 'rule4'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '99899aa7-7c5e-4de2-873f-5378c9a587fb',
      name: 'Loetje Leeuwarden',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: 'bb344a63-4840-4afc-9320-4ff0d411ee85',
      name: 'Loetje Leiden',
      excludedDates: OTHER_PUBLIC_HOLIDAYS
    },
    {
      id: 'fc26a292-ce6f-4135-a6d7-c103ae956ef0',
      name: 'Loetje Maastricht',
      timeslotsFilterCb: (timeslot) => {
        return ['rule2'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '9203dd5b-93e7-4498-92bd-70e86e8cab5d',
      name: 'Loetje Nijmegen',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '28e4f8d5-6934-49c7-9730-7b49cfa4d79d',
      name: 'Loetje Ouderkerk aan de Amstel',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2', 'rule3', 'rule4'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '9a6177e2-0d9b-48eb-84a1-fafff4074733',
      name: 'Loetje Overveen',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2', 'rule3'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '214359e2-ce29-43d9-b439-5cb6765673de',
      name: 'Loetje Paterswolde',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '1334954c-211b-405f-b4a6-369a684dcb86',
      name: 'Loetje Reeuwijk',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '31cb5eee-6399-4d2a-a99d-2978aeb35007',
      name: 'Loetje Rotterdam Centrum',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '3f9cefaa-c00a-40c6-96ba-0047725c050b',
      name: 'Loetje Rotterdam Kop van Zuid',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '70d0ea6f-0da9-499f-8063-380ccf0b3e66',
      name: 'Loetje Utrecht',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2', 'rule4'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: 'deda9f31-5bf1-4efa-8e1d-7dc2f1d6fd21',
      name: 'Loetje Vught',
      excludedDates: OTHER_PUBLIC_HOLIDAYS,
      timeslotsFilterCb: (timeslot) => {
        return ['rule2', 'rule3'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '1909edb7-0cdb-46dc-8010-d1a8ea05bf76',
      name: 'Loetje Zeist'
    },
    {
      id: '688f61d3-278c-4283-acc3-3570e7b8c9df',
      name: 'Loetje Zwolle',
      excludedDates: OTHER_PUBLIC_HOLIDAYS
    }
  ]
}

module.exports = config
